<template>
    <div>
        <section class="base-header-sec base-header-laen  laen">
            <div class="base-header__top-line laen"></div>
            <div class="container-fluid">
                <div class="base-header__container">
                    <div class="d-flex justify-content-center align-items-center">
                        <h1 class="base-header__title text-center py-2">
                            Статистика
                        </h1>
                    </div>
                </div>
            </div>
        </section>

        <div class="container-fluid base-container">
            <div id="contentHtml" class="base-box base-box__table-sec">
                <iframe :srcdoc="content" width="100%" height="600px" frameborder="0"></iframe>
            </div>
        </div>
    </div>
</template>

<script>

import * as helper from '@/utils/helper-methods'
import axios from 'axios'

export default {
    name: "FpStatistics",
    data() {
        return {
            loaded: false,
            content: null,
            baseApiUrl: window.env.VUE_APP_API_FP_DEV,

            meta: {
                title: 'Правно-информациони систем РС',
                description: 'Правно-информациони систем je збирка података у електронском облику која садржи: електронски облик Службеног гласника, архиву службених гласила, базу која садржи регистар и текстове важећих прописа и других аката Републике Србије објављених у Службеном гласнику, базу која садржи судску праксу, друге податке о правном систему Републике Србије и везу с правним актима Европске уније.',
                keywords: 'zakoni, akti, zakonski, propisi, sudska praksa, registar, odluka, sudovi, ugovori, pravno informacioni sistem, prins, pis,sluzbeni glasnik',
            },
        }
    },
    metaInfo() {
        return {
            title: this.meta.title,
            meta: [
                { name: 'title', content: this.meta.title },
                { name: 'description', content: this.meta.description },
                { name: 'keywords', content: this.meta.keywords },
            ],
        }
    },
    mounted() {
        axios.get(this.baseApiUrl + 'prins/viewdoc?uuid=40b4c407-096e-454c-814e-4abbd7e485dc&staticpageid=19&doctype=fpstaticpage').then(response => {
            this.content = helper.adjustHtmlContent(response.data)
            helper.attachIframeEventListener();
            this.$nextTick(() => {
                const iframe = document.querySelector('iframe');
                if (iframe) {
                    iframe.onload = () => {
                        //ovo se radi da bi se gadjali linkovi na nasoj produkciji, a ne na njiovoj
                        helper.changeLinks();
                    };
                }
            });
        }).catch(error => {
            console.log(error)
        })
    },
    beforeCreate: function () {
        document.body.className = 'color_standard';
    },

}
</script>

<style scoped></style>
